import { render, staticRenderFns } from "./CommissionSplitTable.vue?vue&type=template&id=7b76e59f"
import script from "./CommissionSplitTable.vue?vue&type=script&lang=js"
export * from "./CommissionSplitTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports